module.exports = __webpack_public_path__ + "static/media/CC20-LC250-12.19e6db20.png";